/**
 * Copyright © Pronko Consulting Ltd. All rights reserved.
 */

import Flickity from "flickity";

/**
 * @class ClientGallery
 * @classdesc Gallery class with use flickity slider
 */
class ClientGallery {
    constructor() {
        this.container = document.querySelector('aside.widget_media_gallery .gallery');
        this.sliderOptions = {
            cellAlign: 'left',
            pageDots: false,
            wrapAround: true,
            pauseAutoPlayOnHover: true,
            autoPlay: 1500,
        }
    }

    animationMarquee() {
        document.addEventListener('DOMContentLoaded', () => {

            // Create marquee client logo block
            const marqueeRow = document.createElement('div');

            if (!this.container)
                return;

            marqueeRow.setAttribute('id', "logos-clients");

            // Append to new block exist images
            this.container.querySelectorAll('.gallery-item').forEach(item => {
                const cloneImage = item.querySelector('img').cloneNode();
                marqueeRow.appendChild(cloneImage);
            })

            // Replace old images with our layout
            this.container.innerHTML = " ";
            this.container.append(marqueeRow);

            // Init slider by Flickity
            const clientLogoFlky = new Flickity('#logos-clients', this.sliderOptions);

            document.getElementById('logos-clients').addEventListener("mouseleave", e => {
                clientLogoFlky.playPlayer();
            })

        });
    }
}

export default ClientGallery;
